import type { ReactNode } from 'react';
import { RulePreview } from '../RulePreview';
import { ModificationItemContent } from './ModificationItemContent';
import { ModificationItemIcon } from './ModificationItemIcon';
import { ModificationItemText } from './ModificationItemText';

export const ModificationItem = ({ children }: { children: ReactNode }) => {
  return <RulePreview>{children}</RulePreview>;
};

ModificationItem.Content = ModificationItemContent;
ModificationItem.Text = ModificationItemText;
ModificationItem.Arrow = RulePreview.Arrow;
ModificationItem.Icon = ModificationItemIcon;
